<template>
    <b-container fluid>
        <div>
            <b-row>
                <b-col cols="6">
                    <label for="venue">Seleccione una sede</label>
                    <app-form-select
                        id="venue"
                        :options="venues"
                        v-model="venueId"
                        @change="loadWorkplaces"
                        value-field="id"
                        text-field="name"
                    ></app-form-select>
                </b-col>
                <b-col cols="6">
                    <label for="workplace">Puesto de trabajo</label>
                    <app-form-select
                        id="workplace"
                        :options="workplaces"
                        value-field="id"
                        text-field="name"
                        v-model="door.structureId"
                        @change="$v.door.structureId.$touch()"
                        :valid="!$v.door.structureId.$error"
                    ></app-form-select>
                </b-col>   
            </b-row>
            <b-row class="mt-2">
                <b-col cols="6">
                    <label for="title">Nombre</label>
                    <b-form-input
                        type="text"
                        id="title"
                        v-model="door.name"
                    ></b-form-input>
                </b-col>
                <b-col cols="6">
                    <label for="level">Nivel</label>
                    <b-form-input
                        type="number"
                        id="level"
                        v-model="door.level"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="py-2">
                    <label for="description">Descripción</label>
                    <b-form-textarea
                        v-model="door.description"
                    ></b-form-textarea>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import { required, numeric } from 'vuelidate/lib/validators'
export default {
    data: () => ({
        door: {
            structureId: '',
            name: '',
            level: '',
            description: ''
        },
        venues: [],
        workplaces: [],
        venueId: '',
        editing: false,
        currentDoor: ''
    }),
    validations: {
        door:{
            structureId: { required, numeric}
        }
    },
    methods: {
        async saveDoor(){
            const { data } = !this.editing ? await repo.post('doors', this.door)
            : await repo.put(`doors/${this.currentDoor.id}`, this.door)

            if(data.status){
                this.$emit('saved-door', data)
                this.reset()
                this.editing = false
            }else{
                return toastr.error('Ha ocurrido un error')
            }
        },
        async loadVenues() {
            const { data } = await repo.get('venues', {
                client: this.client.id,
            })
            this.venues = data
        },
        async loadWorkplaces(venueId) {
            const { data } = await repo.get('resources/workplaces', {
                venueId,
                clientId: this.client.id,
            })
            this.workplaces = data
        },
        reset() {
            this.venueId = ''
            Object.keys(this.door).map(key => (this.door[key] = ''))
        },
        fill(door){
            this.venueId = door.structure.venue.id
            this.door.name = door.name
            this.door.description = door.description
            this.door.level = door.level
            this.editing = true
            this.loadWorkplaces(door.structure.venue.id)
            this.door.structureId = door.structure.id
            this.currentDoor = door
        }
    },
    mounted(){
        this.loadVenues()
    }
}
</script>